import { SupportTicket } from '#/api/types';
import { formatDate } from '#/utils';
import styles from './Support.module.scss';

export const TicketHeader = ({ ticket }: { ticket: SupportTicket }) => {
  const statuses = {
    2: 'Open',
    3: 'Pending',
    4: 'Resolved',
    5: 'Closed',
  };

  return (
    <div className={styles.ticketHeader}>
      <h3>{ticket.subject}</h3>
      <div className={styles.ticketStats}>
        <div>Last update at: {formatDate(ticket.updatedAt)}</div>
        <div>Status: {statuses[ticket.status]}</div>
      </div>
    </div>
  );
};
